import React from "react"
import "./frames.css"

const Formacion = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">Formación y Cualificación</h1>
      <p className="frames-text">
        OXANA, en asociación con el Instituto Español de Medicina Hiperbárica
        (IEMH), brinda oportunidades de formación para operadores de cámaras
        hiperbáricas.
      </p>

      <h2 className="frames-subtitle">Reconocimiento Institucional</h2>
      <p className="frames-text">
        Los cursos están acreditados y reconocidos por diversos organismos
        sanitarios tanto a nivel nacional como europeo. Esto añade un valor
        significativo a la cualificación obtenida y facilita el reconocimiento
        profesional en el campo de la medicina hiperbárica.
      </p>

      <h2 className="frames-subtitle">Prácticas en Centros Equipados</h2>
      <p className="frames-text">
        Los participantes del curso tienen la oportunidad de realizar prácticas
        en distintos centros, todos ellos equipados con cámaras hiperbáricas de
        Perry Baromedical. Esto permite una experiencia práctica enriquecedora,
        que complementa la formación teórica.
      </p>

      <h2 className="frames-subsection">Para más información</h2>
      <p className="frames-text">
        Si desea obtener más información acerca de la formación en operación de
        cámaras hiperbáricas, no dude en ponerse en contacto con el IEMH a
        través de la dirección de correo electrónico secretaria@iemh.es.
      </p>
    </div>
  )
}

export default Formacion
